import React, { PureComponent } from 'react';
import { Box, Paper, Typography, Grid, TextField } from '@material-ui/core';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { jobTitles, location } from 'controllers/taxonomies';

class AboutCompany extends PureComponent {
  fetchJobTitles = async (value) => {
    const titles = await jobTitles(value);
    return await titles.response.map((title) => title['job title']);
  };

  fetchLocations = async (value) => {
    const locations = await location(value);
    return await locations.response.map(
      ({ name, country }) => `${name}, ${country}`
    );
  };

  onChangeDescription = (value) => {
    const { onUpdateOrganization } = this.props;
    if (onUpdateOrganization) {
      onUpdateOrganization('aboutCompany', value);
    }
  };

  onChangeFoundedYear = (e) => {
    const { onUpdateOrganization } = this.props;
    onUpdateOrganization('foundedYear', e.target.value);
  };

  onChangeLocation = (e) => {
    const { onUpdateOrganization } = this.props;
    onUpdateOrganization('location', e.target.value);
  };

  onChangeCompanySize = (e) => {
    const { onUpdateOrganization } = this.props;
    onUpdateOrganization('companySize', e.target.value);
  };

  render() {
    const { location, foundedYear, companySize, aboutCompany } = this.props;

    return (
      <Paper square elevation={0} className="about-company" id="about-company">
        <Box pb="25px">
          <Typography variant="body1" className="font-weight-500">
            About
          </Typography>
        </Box>
        <Box>
          <Grid container spacing={2} justify="center">
            <Grid item xs={6}>
              <Box>
                <TextField
                  label="Founded in"
                  variant="outlined"
                  value={foundedYear}
                  onChange={this.onChangeFoundedYear}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <TextField
                  label="Number of employee"
                  variant="outlined"
                  value={companySize}
                  onChange={this.onChangeCompanySize}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <TextField
                  label="Main office location"
                  variant="outlined"
                  onChange={this.onChangeLocation}
                  value={location}
                  fullWidth
                />
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={2} justify="center">
          <Grid item xs={12}>
            <Box>
              <div className="RichEditor-root">
                <ReactQuill
                  // editorState={description}
                  onChange={this.onChangeDescription}
                  placeholder="Description"
                  modules={{
                    toolbar: [
                      [{ align: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline', 'blockquote'],
                      [{ size: [] }],
                    ],
                  }}
                  formats={[
                    'align',
                    'list',
                    'bullet',
                    'bold',
                    'italic',
                    'underline',
                    'blockquote',
                    'size',
                  ]}
                  value={aboutCompany}
                />
              </div>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default AboutCompany;
